import React from "react";

export default function AssetPhotosCard()
{
    const photos =
    [
        "https://picsum.photos/400/300?1",
        "https://picsum.photos/400/300?2",
        "https://picsum.photos/400/300?3",
        "https://picsum.photos/400/300?4",
        "https://picsum.photos/400/300?5",
        "https://picsum.photos/400/300?6"
    ];

    return (

        <div
            style={{
                width: "100%",
                background: "#f7f9fc",
                border: "1px solid #e3e9f0",
                borderRadius: "14px",
                overflow: "hidden",
                boxShadow: "0 10px 24px rgba(0,0,0,.08)"
            }}
        >

            {/* Header */}

            <div
                style={{
                    background: "#eef3f8",
                    borderBottom: "1px solid #dde4ec",
                    padding: "16px 22px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}
            >

                <div
                    style={{
                        fontSize: "24px",
                        fontWeight: "bold",
                        color: "#333"
                    }}
                >
                    📷 Photos
                </div>

                <div
                    style={{
                        background: "#eef6ff",
                        color: "#5a9bd6",
                        borderRadius: "999px",
                        padding: "5px 12px",
                        fontSize: "11px",
                        fontWeight: "bold"
                    }}
                >
                    {photos.length} Photos
                </div>

            </div>

            {/* Upload */}

            <div style={{ padding: "20px" }}>

                <label
                    style={{
                        display: "block",
                        border: "2px dashed #bfd3e8",
                        borderRadius: "12px",
                        background: "#fbfcfe",
                        padding: "28px",
                        textAlign: "center",
                        cursor: "pointer",
                        transition: ".2s"
                    }}
                >

                    <div
                        style={{
                            fontSize: "42px",
                            marginBottom: "8px"
                        }}
                    >
                        📸
                    </div>

                    <div
                        style={{
                            fontWeight: "bold",
                            color: "#333",
                            marginBottom: "6px"
                        }}
                    >
                        Upload Photos
                    </div>

                    <div
                        style={{
                            color: "#777",
                            fontSize: "13px"
                        }}
                    >
                        Click or drag images here
                    </div>

                    <input
                        type="file"
                        multiple
                        accept="image/*"
                        style={{ display: "none" }}
                    />

                </label>

            </div>

            {/* Gallery */}

            <div
                style={{
                    padding: "0 20px 20px",
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill,minmax(170px,1fr))",
                    gap: "14px"
                }}
            >

                {
                    photos.map((photo, index) =>

                        <div
                            key={index}
                            style={{
                                borderRadius: "10px",
                                overflow: "hidden",
                                background: "#ddd",
                                boxShadow: "0 3px 10px rgba(0,0,0,.08)",
                                cursor: "pointer",
                                position: "relative"
                            }}
                        >

                            <img
                                src={photo}
                                alt=""
                                style={{
                                    width: "100%",
                                    height: "150px",
                                    objectFit: "cover",
                                    display: "block"
                                }}
                            />

                            <div
                                style={{
                                    position: "absolute",
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    background: "rgba(0,0,0,.55)",
                                    color: "#fff",
                                    fontSize: "12px",
                                    padding: "6px 10px"
                                }}
                            >
                                Photo {index + 1}
                            </div>

                        </div>

                    )
                }

            </div>

        </div>

    );
}